<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-dialog persistent
                  v-model="$store.getters.bookHistoryModal"
                  max-width="1000">

            <v-card>
                <v-card-title
                        class="headline primary white--text"
                        primary-title>
                    Ιστορικό Συγγράμματος
                </v-card-title>

                <v-card-text class="mt-5">
                    <v-data-table
                            no-data-text="Δεν υπάρχουν δεδομένα."
                            :headers="headers"
                            :items="bookHistory"
                            :items-per-page="5"
                            sort-by="year"
                            class="elevation-1">

                        <template v-slot:item.penalty="{ item }">
                                {{ item.penalty }} %
                        </template>
                    </v-data-table>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            text
                            @click="closeModal">
                        Κλείσιμο
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
    export default {
        name: "BookHistory",
        data: () => ({
            headers: [
                {
                    text: 'Ακαδημαϊκό Έτος',
                    align: 'start',
                    value: 'year',
                },
                { text: 'Εγκριθείσα Τιμή Κοστολόγησης', value: 'price' },
                { text: 'Τιμή Κοστολόγησης', value: 'suggestedPrice' },
                { text: 'Πρακτικό Κοστολόγησης', value: 'decisionNumber' },
                { text: 'Penalty', value: 'penalty' },
            ],
        }),

        props: {
            bookHistory: Array
        },

        methods: {

            closeModal(){
                this.$store.commit('setBookHistoryModal', false);
            }
        }
    }
</script>

<style scoped>

</style>